<mat-grid-list [cols]="cols$ | async" class="home-buttons" gutterSize="24px" rowHeight="20:10">
  <mat-grid-tile *ngFor="let item of activeLinks" [style.background-color]="item.color" class="home-button" matRipple>
    <a (click)="popupAction(item.link)" *ngIf="item.popup" [title]="item.title">
      <mat-icon>{{item.icon}}</mat-icon>
      {{item.title}}
    </a>
    <a *ngIf="!item.popup" [routerLink]="item.link" [title]="item.title">
      <mat-icon>{{item.icon}}</mat-icon>
      {{item.title}}
    </a>
  </mat-grid-tile>
</mat-grid-list>
